import React from 'react';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { BaseTextFieldProps } from '@/types';

interface DocumentNameFieldProps extends BaseTextFieldProps {}

export default function DocumentNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}: DocumentNameFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Document name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Document name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Name'
          id='name'
          aria-describedby='name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={false}
          slotProps={{ inputLabel: { shrink: value?.length > 0 } }}
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter a name for the document
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
